import { Checkbox as KobalteCheckbox } from "@kobalte/core/checkbox"
import type { AccentHue } from "@repo/fika-design-system/color"
import type { JSX } from "solid-js"
import { Show } from "solid-js"
import { Box } from "./box"
import {
  checkboxClass,
  checkboxControlRecipe,
  checkboxDescriptionClass,
  checkboxIndicatorClass,
  checkboxInputClass,
  checkboxLabelClass,
} from "./checkbox.css"
import { Icon } from "./icon"

type Props = {
  label: string | JSX.Element
  checked: boolean
  onChange: (checked: boolean) => void
  hue?: AccentHue
  disabled?: boolean
  description?: string
}

export function Checkbox(props: Props) {
  return (
    <KobalteCheckbox
      checked={props.checked}
      onChange={props.onChange}
      disabled={props.disabled}
      class={checkboxClass}
    >
      <KobalteCheckbox.Input class={checkboxInputClass} />
      <KobalteCheckbox.Control
        class={checkboxControlRecipe({ hue: props.hue })}
      >
        <KobalteCheckbox.Indicator class={checkboxIndicatorClass}>
          <Icon name="check" size="18" color="base0" />
        </KobalteCheckbox.Indicator>
      </KobalteCheckbox.Control>

      <Box>
        <KobalteCheckbox.Label class={checkboxLabelClass}>
          {props.label}
        </KobalteCheckbox.Label>

        <Show when={props.description}>
          <KobalteCheckbox.Description class={checkboxDescriptionClass}>
            {props.description}
          </KobalteCheckbox.Description>
        </Show>
      </Box>
    </KobalteCheckbox>
  )
}
